import React, { useMemo, useEffect, useRef } from 'react'
import Checkbox from '../../../common/element/Checkbox'

const QUESTIONS_PER_STEP = 18

const StepComponent = ({
    quizResult=[],
    step = 1,
    questions = [],
    selected = {},
    onChange
}) => {
    const scrollContainerRef = useRef(null)
console.log(quizResult ,"quizResultquizResultquizResultquizResult")
    // Scroll to top when step changes
    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = 0
        }
    }, [step])

    // Get only the questions for the current step
    const currentStepQuestions = useMemo(() => {
        const startIndex = (step - 1) * QUESTIONS_PER_STEP
        const endIndex = startIndex + QUESTIONS_PER_STEP
        return questions.slice(startIndex, endIndex)
    }, [questions, step])

    // Count answered questions for this step
    const answeredCount = useMemo(() => {
        return Object.values(selected || {}).filter((v) => v && v.value).length
    }, [selected])

    const handleSelect = (question, optionType) => {
        const next = { ...(selected || {}) }
        const questionId = question.id
        
        // Get the value based on option type (a or b)
        const selectedValue = optionType === 'a' 
            ? question.option[0].value_of_a 
            : question.option[1].value_of_b
        
        // Toggle selection - if same option clicked, uncheck it
        if (next[questionId]?.value === selectedValue) {
            delete next[questionId]
        } else {
            next[questionId] = {
                selectedOptionId: questionId,
                value: selectedValue
            }
        }
        onChange?.(next)
    }

    return (
        <div className="flex flex-col h-full">
            {/* Instructions */}
            <div className="p-3 md:p-6 bg-[#FFF4E5] border border-[#FFF4E5] rounded-[12px] mb-4">
                <div className="flex items-center gap-2.5 mb-1.5">
                    <div className="flex-shrink-0 ">
                        <div className="w-2 h-2 rounded-full bg-[#FF8E1C]"></div>
                    </div>
                    <p className="font-lato not-italic font-bold text-[16px] md:text-[20px] lg:text-[20px] mobile_fix  text-start lg:text-center leading-[115%] text-black">
                        Each question has two options "a" & "b".
                    </p>
                </div>
                <div className="flex items-center gap-2.5">
                    <div className="flex-shrink-0 ">
                        <div className="w-2 h-2 rounded-full bg-[#FF8E1C]"></div>
                    </div>
                    <p className="font-lato not-italic font-bold text-[16px] md:text-[20px] lg:text-[20px] mobile_fix  text-start lg:text-center leading-[115%] text-black">
                        Select the option which truly reflects you instead of what seems to be right
                    </p>
                </div>
            </div>

            {/* Questions */}
            <div
                ref={scrollContainerRef}
                className="flex-1 overflow-y-auto pr-2 space-y-4 mb-6"
                style={{ maxHeight: 'calc(100vh - 350px)' }}
            >
                {currentStepQuestions.map((question, index) => {
                    const value = selected?.[question.id] || null
                    const globalQuestionNumber = (step - 1) * QUESTIONS_PER_STEP + index + 1

                    return (
                        <div key={question.id} className="p-3 md:p-6 border border-[#FFD7A1] rounded-[12px]">
                            <div className="mb-6 flex">
                                <span className="font-lato not-italic font-bold text-[18px] md:text-[20px] text-start md:text-center leading-[115%] text-black">
                                    Question {globalQuestionNumber}
                                </span>
                            </div>

                            <div className="space-y-3">
                                <label className="flex items-start md:items-center gap-3 cursor-pointer group">
                                    <div className="mt-0.5">
                                        <Checkbox
                                            checked={value?.value === question.option[0].value_of_a}
                                            onChange={() => handleSelect(question, 'a')}
                                        />
                                    </div>
                                    <span className="font-lato font-semibold text-[14px] leading-[18px] text-black text-start">
                                        a) {question.option[0].option_a}
                                    </span>
                                </label>

                                <label className="flex items-start md:items-center gap-3 cursor-pointer group">
                                    <div className="mt-0.5">
                                        <Checkbox
                                            checked={value?.value === question.option[1].value_of_b}
                                            onChange={() => handleSelect(question, 'b')}
                                        />
                                    </div>
                                    <span className="font-lato font-semibold text-[14px] leading-[18px] text-black text-start">
                                        b) {question.option[1].option_b}
                                    </span>
                                </label>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default StepComponent